import { getDocument } from 'pdfjs-dist';
import { parseGIF, decompressFrames } from 'gifuct-js'
import { maxFilesPerNetwork, listNetworkSort} from './constante'
import FastAverageColor from 'fast-average-color';


const fac = new FastAverageColor();

// Video multi-personalization (StandardTab.vue/PostCreator.vue): matches a `files` entry against
// the STABLE identity of an edited video (its `fileIdOrigin`, set once at the very first edit and
// carried forward on every re-encode) rather than the transient `id` a session captured when it
// started. Two scopes (e.g. general + a page/network personalization) can both start from the
// same inherited entry and finish concurrently - whichever concludes second would otherwise try to
// match an `id` that the first one already replaced in the shared base array it fell back to,
// silently failing to find anything and dropping its own edit. `f.id === fileIdOrigin` covers a
// never-yet-edited entry (its own id IS the origin, by construction - see startEditVideoOrigin).
export const matchesVideoOrigin = (f, fileIdOrigin) => {
    return f.id === fileIdOrigin || (f.mediaEditorData && f.mediaEditorData.fileIdOrigin === fileIdOrigin)
}

// Une page instagram est "native" (conciergerie) uniquement si sa session directe est active.
// story_config.created repasse a false des que la connexion est perdue (disconnectDirectApi).
export const isNativeInstagram = (page) => {
    return !!(page && page.network === 'instagram' && page.story_config && page.story_config.created)
}

// Les formulaires reseau sont partages entre TOUTES les pages selectionnees du reseau quand la
// personnalisation par page est desactivee (voir Form.vue, qui ne restreint a une page que si
// idPageRenderNetworkSelected est defini). Une fonctionnalite native n'est donc proposee que si
// TOUTES les pages instagram selectionnees sont natives : avec un `some`, une page deconnectee
// recevait des donnees natives (identifications, collaborateurs, lieu, musique, produits) des
// qu'une autre page native etait dans la selection. Meme regle que l'app mobile
// (mwapp InstagramSettings.tsx).
export const allInstagramNative = (pages) => {
    const instagramPages = (pages || []).filter(page => page && page.network === 'instagram')
    return instagramPages.length > 0 && instagramPages.every(isNativeInstagram)
}

// Vrai si au moins une page instagram est selectionnee et qu'AUCUNE n'est native - la recherche
// necessite une session native pour resoudre un nom en compte ; sans ca (selection 100% API),
// seule la saisie manuelle (username tape) reste possible. Une selection mixte (au moins une page
// native) utilise la recherche, meme pour les pages API du meme envoi - buildUserTags/
// buildCollaboratorUsernames (controllers/instagram.js) ne lisent que `username`, jamais l'id
// numerique, donc un tag resolu par recherche fonctionne pour les deux.
export const allInstagramNonNative = (pages) => {
    const instagramPages = (pages || []).filter(page => page && page.network === 'instagram')
    return instagramPages.length > 0 && instagramPages.every(page => !isNativeInstagram(page))
}

export const isNativeFacebook = (page) => {
    return !!(page && page.network === 'facebook' && page.story_config && page.story_config.created)
}

export const allFacebookNative = (pages) => {
    const facebookPages = (pages || []).filter(page => page && page.network === 'facebook')
    return facebookPages.length > 0 && facebookPages.every(isNativeFacebook)
}

// Recale une date/heure planifiee si elle est dans le passe (ou trop proche), meme convention
// que checkValidDate/checkValidHours (Form.vue, FormStory.vue, FormStoryFacebook.vue) : marge de 10 minutes.
export const getValidPlanifiedDateTime = (date, hours) => {
    const currentDate = new Date(Date.now() + 600000)
    const currentDateStr = currentDate.toLocaleString('fr-FR').split(' ')[0].split('/').reverse().join('-')
    const currentHoursStr = `${String(currentDate.getHours()).padStart(2, '0')}:${String(currentDate.getMinutes()).padStart(2, '0')}`

    if (!date) return { date: currentDateStr, hours: currentHoursStr }

    let [h, m] = String(hours || '09:00').replace('h', ':').split(':').map(value => isNaN(value) ? 0 : parseInt(value))
    h = Math.max(0, Math.min(24, h))
    m = Math.max(0, Math.min(59, m))

    const planifiedDate = new Date(date)
    planifiedDate.setHours(h)
    planifiedDate.setMinutes(m)

    if (planifiedDate < currentDate) {
        return { date: currentDateStr, hours: currentHoursStr }
    }
    return { date, hours: `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}` }
}

export const getPlanifiedDateISO = (planifiedDate) => {
    if (planifiedDate && planifiedDate.date && planifiedDate.hours) {
        return new Date(`${planifiedDate.date}T${planifiedDate.hours.replace('h', ':')}:00`).toISOString()
    }
    return new Date().toISOString()
}

//getFilesByNetwork(medias = this.formData.files, networks = this.listNetworkSort, formDataNetwork = this.formData.formDataNetwork, files = this.files, isUploadRequired = false)
export const getFilesByNetwork = (medias, networks, formDataNetwork, files, isUploadRequired = false) => {
    console.log("getFilesByNetwork",{networks,files,medias})
    let filesPerNetwork = {}
    networks.forEach(networkName => {
        filesPerNetwork[networkName] = medias.reduce((filesAccumulator,media) => {
            //echec de de l'upload
            console.log("getFilesByNetwork media", media)

            if (!files[media.id] || (!files[media.id].isUpload && (isUploadRequired || !files[media.id].uploadProgress))) return filesAccumulator
            const file = files[media.id];

            if (file.errorNetwork.hasOwnProperty(networkName)) return filesAccumulator
          
            switch (networkName) {
                case 'facebook':
                    if (formDataNetwork.facebook.typeMedia == 'mixed') break;
                    if (formDataNetwork.facebook.typeMedia == 'video' && file.info.type2 !== 'video') return filesAccumulator
                    if (formDataNetwork.facebook.typeMedia == 'image' && (file.info.type2 !== 'image' || file.info.type == 'image/gif')) return filesAccumulator
                    break;
                case 'instagram':
                    if (!['video', 'image'].includes(file.info.type2) || file.info.type == 'image/gif') return filesAccumulator      

                    break;
                case 'linkedin':
                    if (formDataNetwork.linkedin.survey && formDataNetwork.linkedin.survey.active) return filesAccumulator
                    if (formDataNetwork.linkedin.typeMedia == 'video' && (file.info.type2 !== 'video' || filesAccumulator.some(f => f.info.type2 == 'video'))) return filesAccumulator
                    if (file.info.type2 !== formDataNetwork.linkedin.typeMedia) return filesAccumulator
                    break;
                case 'threads':
                    if (!['video', 'image'].includes(file.info.type2) || file.info.type == 'image/gif') return filesAccumulator
                    break;
                case 'twitter':
                    if (formDataNetwork.twitter.typeContent == 'video' && (file.info.type2 !== 'video' || filesAccumulator.some(f => f.info.type2 == 'video'))) return filesAccumulator
                    if (file.info.type2 !== formDataNetwork.twitter.typeContent) return filesAccumulator
                    break;
                case 'bluesky':
                    if (!['video', 'image'].includes(file.info.type2) || file.info.type == 'image/gif') return filesAccumulator
                    if (filesAccumulator.length > 0 && filesAccumulator[0].info.type2 !== file.info.type2) return filesAccumulator
                    break;
                case 'tiktok':
                    if (!['video', 'image'].includes(file.info.type2) || file.info.type == 'image/gif') return filesAccumulator
                    if (file.info.type2 === 'video' && filesAccumulator.some(f => f.info.type2 === 'video')) return filesAccumulator
                    if (file.info.type2 === 'video' && filesAccumulator.some(f => f.info.type2 === 'image')) return filesAccumulator
                    if (file.info.type2 === 'image' && filesAccumulator.some(f => f.info.type2 === 'video')) return filesAccumulator
                    break;
                case 'google':
                    if (file.info.type2 !== 'image' || file.info.type == 'image/gif' || filesAccumulator.some(f => f.info.type2 == 'image')) return filesAccumulator
                    break
                case 'telegram':
                    return filesAccumulator
                case 'pinterest':
                    if (!['video', 'image'].includes(file.info.type2) || file.info.type == 'image/gif' || filesAccumulator.some(f => ['video', 'image'].includes(f.info.type2))) return filesAccumulator
                    break;
                case 'youtube':
                    if (file.info.type2 !== 'video' || filesAccumulator.some(f => f.info.type2 == 'video')) return filesAccumulator
                    break;
                
                default:

                    break;
            }

            let imagePreview = null
            if (media.imagePreview && media.imagePreview.id && files[media.imagePreview.id]) {
                const previewFile = files[media.imagePreview.id];
                const url = previewFile.normalizedNetworks[networkName] && previewFile.normalizedNetworks[networkName].url ? previewFile.normalizedNetworks[networkName].url : previewFile.url
                imagePreview = {
                    id: previewFile.id,
                    url: url,
                    type: previewFile.info.type,
                    enclosure: url,
                };
            }


            const info = {...file.info, ...(file.normalizedNetworks && file.normalizedNetworks[networkName] && file.normalizedNetworks[networkName].info ? file.normalizedNetworks[networkName].info : {})}
            let fileData = {
                ...file,
                ...info,
                imagePreview,
                info,
                url : file.normalizedNetworks && file.normalizedNetworks[networkName] && file.normalizedNetworks[networkName].url ? file.normalizedNetworks[networkName].url : file.url,
            };

            return [...filesAccumulator, fileData]

        },[])
        
        if (networkName == 'instagram') {
            //retire les video excedant 60 secondes si c'est un carousel
            if (filesPerNetwork['instagram'].length > 1) {
                if (filesPerNetwork['instagram'][0].info.type2 == 'video' && filesPerNetwork['instagram'][0].info.duration > 60) {
                    filesPerNetwork[networkName] =  filesPerNetwork[networkName].slice(0,1)
                }else{
                    const excludeLongVideo = filesPerNetwork['instagram'].filter(file => file.info.type2 !== 'video' || file.info.duration <= 60)
                    if (excludeLongVideo.length == 0) {
                        filesPerNetwork[networkName] =  filesPerNetwork[networkName].slice(0,1)
                    }else{
                        filesPerNetwork[networkName] = excludeLongVideo
                    }
                }
            }
        }
        
        filesPerNetwork[networkName] = filesPerNetwork[networkName].slice(0,maxFilesPerNetwork[networkName])
    })
    return filesPerNetwork
}

export const getInfoFile = async (file, url) => {
    console.log("getInfoFile", {file, url})
    const infoFile = {
        name:undefined,
        size:undefined,
        type:undefined,
        type2:undefined,
        width: undefined,
        height: undefined,
        aspectRatio: undefined,
        framesLength: undefined,
        averageColor: undefined,
        enclosure: undefined
    }

    infoFile.name = file.name
    infoFile.size = file.size
    infoFile.type = file.type

    infoFile.type2 = ['image','video'].includes(file.type.split('/')[0]) ? 
            file.type.split('/')[0]
        : ['pdf'].includes(file.type.split('/')[1]) ?
            file.type.split('/')[1]
        : undefined;
    
    // get dimensions & averageColor
    if (infoFile.type && url) { 
        

        if (infoFile.type.startsWith('image/')) {
            let img = new Image();
            infoFile.enclosure = url
            await new Promise((resolve) => {
                img.onload = async (e) => {
                    infoFile.width= img.width,
                    infoFile.height= img.height,
                    infoFile.aspectRatio= img.width / img.height
         
                    let facColor = await fac.getColorAsync(e.target);
                    if (facColor.hex) infoFile.averageColor = facColor.hex
                    resolve();
                };
                img.onerror = () => {
                    resolve();
                };
                img.src = url;
            });
        }

        if (infoFile.type == 'image/gif') {
            infoFile.enclosure = url
            let buffer = await fileToArrayBuffer(file);
            let gif = parseGIF(buffer);
            let frames = decompressFrames(gif, false);
            infoFile.framesLength= frames.length
        }

        if (infoFile.type.startsWith('video/')) {
            let video = document.createElement('video');
            video.preload = 'auto';
            video.src = url;
            video.muted = true;
            video.crossOrigin = 'anonymous'; 

            await new Promise((resolve) => {
                video.onloadedmetadata = async (e) => {
                    infoFile.width = video.videoWidth;
                    infoFile.height = video.videoHeight;
                    infoFile.aspectRatio = video.videoWidth / video.videoHeight;
                    infoFile.duration = video.duration;
                    video.currentTime = 0;
                };

                video.onseeked = async () => {
                    const canvas = document.createElement('canvas');
                    canvas.width = video.videoWidth;
                    canvas.height = video.videoHeight;
                    const ctx = canvas.getContext('2d');
                    ctx.drawImage(video, 0, 0);

                    const frameDataUrl = canvas.toDataURL();
                    let facColor = await fac.getColorAsync(frameDataUrl);
                    if (facColor.hex) {
                        infoFile.averageColor = facColor.hex;
                    }

                    infoFile.enclosure = await canvasToBlobURL(canvas, 0.8);

                    if (infoFile.enclosure) {
                        try {
                            const fetchBlob = await fetch(infoFile.enclosure);
                            const blob = await fetchBlob.blob();
                            file = new File([blob], `uploaded-file.${blob.type}`, { type: blob.type });

                             // use s3
                            let uploadUrl = null
                            uploadUrl = await fetch(`${process.env.VUE_APP_API_HOST}/tools/get-upload-url?fileName=${encodeURIComponent(`thumbnail-uploaded-file`)}&fileType=${encodeURIComponent(blob.type)}`, {
                                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
                            })

                            if(uploadUrl && uploadUrl.body && uploadUrl.body.uploadURL && uploadUrl.body.urlFinal) {
                                await axios.put(uploadUrl.body.uploadURL, file, {
                                    headers: {
                                        'Content-Type': info.type
                                    },
                                    onUploadProgress: async (progressEvent) => {
                                        let percentProgress = Math.round((progressEvent.loaded * 100) / progressEvent.total)
                                        if(percentProgress == 100)
                                            infoFile.enclosure = uploadUrl.body.urlFinal
                                    }
                                });

                            }
                            else
                                uploadUrl = null

                            if(!uploadUrl) {

                                const formData = new FormData();
                                formData.append('file', file);

                                const userId = JSON.parse(localStorage.user).id;
                                const response = await fetch(`${process.env.VUE_APP_VIDEO_API_HOST}/image/upload?u=${userId}`, {
                                    method: 'POST',
                                    body: formData
                                });

                                const {file_url} = await response.json();
                                infoFile.enclosure = file_url
                            }
                        } catch(e) {
                            // Nothing ?
                        }
                    }
                   
                    resolve();
                };
        
                video.onerror = () => resolve();
                // video.src = url;
            });
            // video.src = '';
        }

        if (infoFile.type === 'application/pdf') {
            try {
                let doc = await getDocument(url).promise;
                let page = await doc.getPage(1);
                const canvas =  await makeThumb(page)
                infoFile.enclosure = await canvasToBlobURL(canvas, 0.8);
    
                if (infoFile.enclosure) {
                    const fetchBlob = await fetch(infoFile.enclosure);
                    const blob = await fetchBlob.blob();
                    file = new File([blob], `uploaded-file.${blob.type}`, { type: blob.type });
    
                    // use s3
                    let uploadUrl = null
                    uploadUrl = await fetch(`${process.env.VUE_APP_API_HOST}/tools/get-upload-url?fileName=${encodeURIComponent(`thumbnail-uploaded-file`)}&fileType=${encodeURIComponent(blob.type)}`, {
                        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
                    })
                    if(uploadUrl && uploadUrl.body && uploadUrl.body.uploadURL && uploadUrl.body.urlFinal) {
                        await axios.put(uploadUrl.body.uploadURL, file, {
                            headers: {
                                'Content-Type': info.type
                            },
                            onUploadProgress: async (progressEvent) => {
                                let percentProgress = Math.round((progressEvent.loaded * 100) / progressEvent.total)
                                if(percentProgress == 100)
                                    infoFile.enclosure = uploadUrl.body.urlFinal
                            }
                        });

                    }
                    else 
                        uploadUrl = null

                    if(!uploadUrl) {

                        const formData = new FormData();
                        formData.append('file', file);
        
                        const userId = JSON.parse(localStorage.user).id;
                        const response = await fetch(`${process.env.VUE_APP_VIDEO_API_HOST}/image/upload?u=${userId}`, {
                            method: 'POST',
                            body: formData
                        });

                        
                        const {file_url} = await response.json();
                        infoFile.enclosure = file_url
                    }
                }
            } catch (error) {
                console.error(error);
            }
        }
    }

  
    
    return infoFile
}

export const getErrorNetworkFile = (file) => {
   
    const maxSizePerNetwork = {
        image: {facebook:4,twitter:5,instagram:8, google: 5, tiktok: 20},
        video: {facebook:1024,twitter:512, linkedin:5000, instagram:1024, tiktok: 4000}
    }
    const maxDimensionPerNetwork = {
        image: {twitter:'8192x8192', google: '2120x1192', linkedin: 36152320, tiktok: '1080x1080', instagram: '1.91:1'},
        video: {twitter:'8192x8192', linkedin: 36152320, tiktok: '4096x4096'}
    }
    const minDimensionPerNetwork =  {
        image: {twitter:'4x4', google: '250x250', instagram: '9:16'},
        video: {twitter:'4x4', tiktok: '360x360'}
    }
    const maxFrameGif= {twitter: 350,linkedin: 250}
    const maxDurationVideo = {bluesky: 60}
    const minDurationVideo = {instagram: 3}

    const errorNetwork = {}

    const addErrorFile = (network, property, textError) => {
        errorNetwork[network] = {
            ...(errorNetwork[network] || {}),
            [property] : textError
        }
    }

    for (const network of listNetworkSort) {
        const infoFile =  {...file.info, ...(file.normalizedNetworks && file.normalizedNetworks[network] && file.normalizedNetworks[network].info ? file.normalizedNetworks[network].info : {})}

        //size
        if (maxSizePerNetwork[infoFile.type2] && maxSizePerNetwork[infoFile.type2][network]) {
            const sizeInMo = infoFile.size / (1024 * 1024)
            const maxSize = maxSizePerNetwork[infoFile.type2][network]
            if (sizeInMo >= maxSize )
            {
                addErrorFile(network, 'size', `La taille maximum est de ${maxSize}Mo`)
            }
       
        }  

        //Dimension max
        if (maxDimensionPerNetwork[infoFile.type2] && maxDimensionPerNetwork[infoFile.type2][network]) {
            const dimension = maxDimensionPerNetwork[infoFile.type2][network]
            if (Number.isInteger(dimension)) {
                if (infoFile.width * infoFile.height > dimension) {
                    addErrorFile(network,'size', `Le media est trop grand et dépasse les dimensions autorisées.`)
                }
            }else if(dimension.includes('x')){
                const [maxWidth,maxHeight] = dimension.split('x')
                if (infoFile.width > maxWidth || infoFile.height > maxHeight) {
                    addErrorFile(network,'size', `Les dimensions du media ne doivent pas dépasser ${maxWidth} pixels de largeur et ${maxHeight} pixels de hauteur.`)
                }
            }else if (dimension.includes(':')) {
                const [ratioWidth,ratioHeight] = dimension.split(':')
                if (infoFile.aspectRatio > parseFloat(ratioWidth) / parseFloat(ratioHeight)){
                    addErrorFile(network,'size', `Le ratio du media doit être inférieur à ${dimension}.`)
                }
            }
        }

        //Dimension min
        if (minDimensionPerNetwork[infoFile.type2] && minDimensionPerNetwork[infoFile.type2][network]) {
            const dimension = minDimensionPerNetwork[infoFile.type2][network]
            if(Number.isInteger(dimension)){
                if (infoFile.width * infoFile.height < dimension) {
                    addErrorFile(network,'size', `Le media est trop petit et n'atteint pas les dimensions autorisées.`)
                }
            }else if (dimension.includes('x')) {
                const [minWidth,minHeight] = dimension.split('x')
                if (infoFile.width < minWidth || infoFile.height < minHeight) {
                    addErrorFile(network,'size', `Les dimensions du media doivent dépasser ${minWidth} pixels de largeur et ${minHeight} pixels de hauteur.`)
                }
            }else if (dimension.includes(':')) {
                const [ratioWidth,ratioHeight] = dimension.split(':')
                if (infoFile.aspectRatio < parseFloat(ratioWidth) / parseFloat(ratioHeight)){
                    addErrorFile(network,'size', `Le ratio du media doit être supérieur à ${dimension}.`)
                }
            }
        }

        //max frame gif
        if (maxFrameGif[network] && infoFile.framesLength && Number.isInteger(infoFile.framesLength)) {
            if (infoFile.framesLength > maxFrameGif[network]) {
                addErrorFile(network,'frame', `Le GIF dépasse le nombre maximum de frames autorisées.`)
            }
        }

        //max duration video
        if (maxDurationVideo[network] && infoFile.duration) {
            if (infoFile.duration > maxDurationVideo[network]) {
                addErrorFile(network,'duration', `La vidéo dépasse la durée maximum autorisée de ${maxDurationVideo[network]} secondes.`)
            }
        }

        //min duration video
        if (minDurationVideo[network] && infoFile.type2 === 'video' && infoFile.duration !== undefined && infoFile.duration !== null) {
            if (infoFile.duration < minDurationVideo[network]) {
                addErrorFile(network, 'size', `La vidéo doit durer au moins ${minDurationVideo[network]} secondes.`)
            }
        }

    }
    console.log("errorNetwork result", errorNetwork)
    return errorNetwork
}

export const findDifferences = (defaultObj, modifiedObj) => {
    let differences = {};

    // try {
    //     if (Object.keys(defaultObj).length !== Object.keys(modifiedObj).length) return modifiedObj
    //     if (Object.keys(defaultObj).join('') !== Object.keys(modifiedObj).join('')) return modifiedObj
    // } catch (error) {
    //     return modifiedObj
    // }

    if (typeof modifiedObj !== 'object' && modifiedObj !== null) return modifiedObj
    if (typeof defaultObj !== 'object' || defaultObj === null) return modifiedObj

    const allKeys = [...(new Set(Object.keys(defaultObj).concat(Object.keys(modifiedObj))))]
    
    // Parcourir les propriétés de l'objet par défaut
    for (let key of allKeys) {
        if (!modifiedObj.hasOwnProperty(key)) {
            differences[key] = 'deleted_value'   
        }else if (!defaultObj.hasOwnProperty(key)) {
            differences[key] = modifiedObj[key]
        }else{
            if (typeof defaultObj[key] === 'object' && defaultObj[key] !== null) {
                if (Array.isArray(defaultObj[key])) {
                    // Comparer les tableaux
                    if (JSON.stringify(defaultObj[key]) !== JSON.stringify(modifiedObj[key])) {
                        differences[key] = modifiedObj[key];
                    }
                } else if (defaultObj[key] instanceof Set) {
                    // Comparer les Set
                    if (JSON.stringify([...defaultObj[key]]) !== JSON.stringify([...modifiedObj[key]])) {
                        differences[key] = modifiedObj[key];
                    }
                } else {
                    // Comparer les objets (récursion)
                    const objDiff = findDifferences(defaultObj[key], modifiedObj[key]);

                    if (typeof objDiff !== 'object' || Object.keys(objDiff).length > 0) {
                        differences[key] = objDiff;
                    }
                }
            } else {
                // Comparer les valeurs primitives
                if (defaultObj[key] !== modifiedObj[key]) {
                    differences[key] = modifiedObj[key];
                }
            }
        }
    }
    return differences;
}

export const mergeUpdates = (defaultObj, updateObj) => {
    for (let key in updateObj) {
        if (updateObj.hasOwnProperty(key)) {
            // Si la valeur est un objet, on doit faire une fusion récursive
            if (updateObj[key] === 'deleted_value'){
                delete defaultObj[key]
            }else if (typeof updateObj[key] === 'object' && updateObj[key] !== null && !Array.isArray(updateObj[key])) {
                // Si l'objet par défaut n'a pas cette clé, on initialise un objet vide
                if (!defaultObj[key]) {
                    defaultObj[key] = {};
                }
                // Fusion récursive
                mergeUpdates(defaultObj[key], updateObj[key]);
            } else {
                // Sinon, on remplace directement la valeur
                defaultObj[key] = updateObj[key];
            }
        }
    }
    return defaultObj;
}

// Determine quelle page est "mise en avant" (au-dessus de la pile d'avatars) parmi les
// pages d'un même réseau : la page choisie explicitement par l'utilisateur (featuredPageId)
// si elle fait partie de la liste, sinon la règle par défaut - dernier élément de la tranche
// visible de la pile (même tranche que le rendu des avatars : pages.slice(0, length==4?4:3)).
export const getFeaturedPage = (pages, featuredPageId) => {
    if (!pages || !pages.length) return null

    if (featuredPageId) {
        const overridden = pages.find(p => p.id === featuredPageId)
        if (overridden) return overridden
    }

    if (pages.length === 1) return pages[0]

    const sliceCount = pages.length === 4 ? 4 : 3
    const visible = pages.slice(0, sliceCount)
    return visible[visible.length - 1]
}

export const deepClone = (obj) => {
    // Vérifier si c'est un objet ou un tableau
    if (obj === null || typeof obj !== 'object') {
        return obj;
    }

    // Gérer les dates
    if (obj instanceof Date) {
        return new Date(obj);
    }

    // Gérer les tableaux
    if (Array.isArray(obj)) {
        return obj.map(item => deepClone(item));
    }

    // Gérer les objets Set
    if (obj instanceof Set) {
        return new Set([...obj].map(item => deepClone(item)));
    }

    // Gérer les objets Map
    if (obj instanceof Map) {
        return new Map(Array.from(obj.entries()).map(([key, value]) => [deepClone(key), deepClone(value)]));
    }

    // Gérer les autres objets (Object)
    const copy = {};
    for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
            copy[key] = deepClone(obj[key]);
        }
    }
    
    return copy;
}

export const unescapeSpecialChars = (str) => {
    // Remplacer les séquences échappées par leurs équivalents littéraux
    return str
        .replace(/\\n/g, '\n')          // Newline '\n'
        .replace(/\\t/g, '\t')          // Tab '\t'
        .replace(/\\r/g, '\r')          // Carriage return '\r'
        .replace(/\\f/g, '\f')          // Form feed '\f'
        .replace(/\\v/g, '\v')          // Vertical tab '\v'
        .replace(/&nbsp;/g, ' ')        // '&nbsp;' -> space ' '
        .replace(/\\\\/g, '\\');        // Backslash '\\'
}

export const getVideoDuration = (url) => {
    return new Promise((resolve, reject) => {
        const video = document.createElement('video');
        video.src = url;

        video.addEventListener('loadedmetadata', function() {
            resolve(video.duration);  // Renvoie la durée en secondes
        });

        video.addEventListener('error', function() {
            reject('Impossible de charger la vidéo/musique.');
        });
    });
}

const makeThumb = async (page) => {
    // draw page to fit into 96x96 canvas
    var vp = page.getViewport({ scale: 1, });
    var canvas = document.createElement("canvas");
    var scalesize = 1;
    canvas.width = vp.width * scalesize;
    canvas.height = vp.height * scalesize;
    var scale = Math.min(canvas.width / vp.width, canvas.height / vp.height);

    return page.render({ canvasContext: canvas.getContext("2d"), viewport: page.getViewport({ scale: scale }) }).promise.then(function () {
        return canvas; 
    });
}

const fileToArrayBuffer = async (file) => {
    return new Promise((resolve, reject) => {
        let reader = new FileReader();

        reader.onload = function(e) {
            let arrayBuffer = new Uint8Array(reader.result);
            resolve(arrayBuffer)
        }

        reader.readAsArrayBuffer(file);
    });
}

export const customModeIsAvailable = ({
    pagesSelected,
    validator,
    formDataMain,
    files
}) => {
    //retourne les networks concernés ou false
    //reserver au mode standard

    const countPagePerNetwork = pagesSelected.reduce((count, page) => {
        count[page.network] = (count[page.network] || 0) + 1;
        return count;
    }, {});

    const networkSelected = Object.keys(countPagePerNetwork)

    if (!validator) {
        if (!formDataMain) return false
        validator = postNetworkValidator(
            networkSelected,  
            getFilesByNetwork(formDataMain.files, listNetworkSort, formDataMain.formDataNetwork, files),  
            formDataMain.formDataNetwork, 
            formDataMain.textContent
        )
    }

    const networkValidForPersonalization = Object.keys(validator).filter((network) => validator[network].isValid == true && networkSelected.includes(network))

    return (
        networkValidForPersonalization.length && 
        (
            networkValidForPersonalization.length > 1 || 
            countPagePerNetwork[networkValidForPersonalization[0]] > 1
        )
    ) ? networkValidForPersonalization : false
}

export const postNetworkValidator = (networks, filesByNetwork, formDataNetwork, text) => {
    const validator = {}

    networks.forEach(networkName => {
        validator[networkName] = {
            isValid : true,
            showRender : true,
            error : []
        }

        switch (networkName) {
            case 'facebook':
            
                if (
                    !filesByNetwork[networkName].length &&
                    text.length == 0 &&
                    !formDataNetwork[networkName].snippet.link
                ) {
                    validator[networkName].error.push({
                        textError : "Veuillez ajouter au moins un média, un contenu ou un lien."
                    })
                    validator[networkName].isValid = false
                    validator[networkName].showRender = false
                }
                break;

            case 'instagram':
                if (!filesByNetwork[networkName].length) {
                    validator[networkName].error.push({
                        textError : "Veuillez ajouter au moins une image ou une video."
                    })
                    validator[networkName].isValid = false
                    validator[networkName].showRender = false
                }
                break;

            case 'linkedin':
                if (
                    !filesByNetwork[networkName].length &&
                    text.length == 0 &&
                    !formDataNetwork[networkName].snippet.link &&
                    !formDataNetwork[networkName].survey.active
                ) {
                    validator[networkName].error.push({
                        textError : "Veuillez ajouter au moins un média, un contenu, un lien ou un sondage."
                    })
                    validator[networkName].isValid = false
                    validator[networkName].showRender = false
                }
                break;
            case 'threads':
                
                if (
                    !filesByNetwork[networkName].length &&
                    text.length == 0 &&
                    !formDataNetwork[networkName].snippet.link
                ) {
                    validator[networkName].error.push({
                        textError : "Veuillez ajouter au moins un média, un contenu ou un lien."
                    })
                    validator[networkName].isValid = false
                    validator[networkName].showRender = false
                }
                break;
            case 'twitter':
                if (
                    !filesByNetwork[networkName].length &&
                    text.length == 0 &&
                    !formDataNetwork[networkName].snippet.link
                ) {
                    validator[networkName].error.push({
                        textError : "Veuillez ajouter au moins un média, un contenu ou un lien."
                    })
                    validator[networkName].isValid = false
                    validator[networkName].showRender = false
                }
                break;
            case 'bluesky':
                if (
                    !filesByNetwork[networkName].length &&
                    text.length == 0
                ) {
                    validator[networkName].error.push({
                        textError : "Veuillez ajouter au moins un text, une image ou une video."
                    })
                    validator[networkName].isValid = false
                    validator[networkName].showRender = false
                }
                break;
            case 'tiktok':
                if (
                    !filesByNetwork[networkName].length
                ) {
                    validator[networkName].error.push({
                        textError : "Veuillez ajouter au moins une image ou une video."
                    })
                    validator[networkName].isValid = false
                    validator[networkName].showRender = false
                }
                break;
            case 'google':
                if (
                    !filesByNetwork[networkName].length &&
                    !formDataNetwork[networkName].snippet.link
                ) {
                    validator[networkName].error.push({
                        textError : "Veuillez ajouter au moins une image ou un lien."
                    })
                    validator[networkName].isValid = false
                    validator[networkName].showRender = false
                }
                break;
            case 'telegram':
                if (
                    text.length == 0
                ) {
                    validator[networkName].error.push({
                        textError : "Veuillez ajouter un contenu."
                    })
                    validator[networkName].isValid = false
                    validator[networkName].showRender = false
                }
                break;

            case 'pinterest':
                if (
                    !filesByNetwork[networkName].length &&
                    !formDataNetwork[networkName].snippet.link
                ) {
                    validator[networkName].error.push({
                        textError : "Veuillez ajouter au moins une image, une vidéo ou un lien."
                    })
                    validator[networkName].isValid = false
                    validator[networkName].showRender = false
                }
                break;

            case 'youtube':
                if (
                    !filesByNetwork[networkName].length
                ) {
                    validator[networkName].error.push({
                        textError : "Veuillez ajouter une video."
                    })
                    validator[networkName].isValid = false
                    validator[networkName].showRender = false
                }
                break;
            default:
                break;
        }
    });
    
    return validator
}

// Compte, par réseau, les mentions réellement resolues dans un texte.
// Les mentions sont des tokens inline `@<13 chiffres>` dans le texte, dont la cible par réseau
// vit dans le dictionnaire `mentions` a coté (cf. formDataDefault.mentions dans constante.js).
// Un token ne compte pour un réseau que si `mentions[id].mention[network]` est renseigné : une
// mention qui ne cible qu'Instagram ne compte donc pas pour Facebook (elle part en textDefault).
export const countMentionsPerNetwork = (text, mentions = {}) => {
    const countMention = { facebook: 0, instagram: 0, linkedin: 0, twitter: 0, bluesky: 0, tiktok: 0 };

    if (text) {
        const matches = text.matchAll(/@(\d{13})/g);
        for (const match of matches) {
            const mention = mentions[match[1]];

            if (mention && mention.mention) {
                Object.keys(mention.mention).forEach(network => {
                    if (mention.mention[network]) {
                        if (!countMention.hasOwnProperty(network)) countMention[network] = 0
                        countMention[network]++;
                    }
                });
            }
        }
    }

    return countMention;
}

// Repere les pages d'un réseau dont le post (ou un commentaire) depasse le seuil sur de mentions
// de maxMentionsSafeByNetwork -> { [pageId]: { count, comments: [{index, count}] } }
// (seules les pages en infraction sont presentes ; objet vide = rien a signaler)
//
// Deux subtilites du modele a trois couches (main -> networks[network] -> pages[pageId]) :
//  - textContent / comments / mentions sont des champs de premier niveau, donc eux-memes
//    personnalisables : la page affichee a l'ecran n'est pas forcement celle en infraction, il faut
//    donc resoudre la chaine d'heritage pour CHAQUE page (cf. generateDataFormRequest, mixins/main.js)
//  - la couche en cours d'edition vit dans `formData`, pas dans `saveAllFormData`, jusqu'au prochain
//    saveFormData : sans les ternaires ci-dessous le compteur afficherait une valeur perimee pour la
//    page qu'on est justement en train de modifier (meme raison que textSwitchPreview, StandardTab.vue)
//
// On resout champ par champ plutot que de deepClone les couches par page : elles portent aussi
// `files` et `storification`, bien trop lourds pour un computed rejoué a chaque frappe.
export const getMentionsOverSafeLimit = ({
    network,
    maxMentions,
    pagesSelected,
    saveAllFormData,
    formData,
    customMode,
    customModeIsAvailable
}) => {
    const result = {}

    if (!maxMentions || !pagesSelected || !saveAllFormData || !formData || !customMode) return result

    const formMain = !customMode.active ? formData : saveAllFormData.main

    pagesSelected.filter(page => page && page.network == network).forEach(page => {
        // La personnalisation est ignorée a l'envoi quand customModeIsAvailable est faux
        // (mixins/main.js) : on compte alors uniquement sur main, comme formDataPatch.
        const layers = [formMain]

        if (customModeIsAvailable) {
            const selection = customMode.selection || {}

            const formByNetwork = customMode.active && selection.network == page.network
                ? formData
                : (saveAllFormData.networks || {})[page.network]

            const formByPage = customMode.active && selection.page && selection.page.id == page.id
                ? formData
                : (saveAllFormData.pages || {})[page.id]

            // du moins prioritaire au plus prioritaire
            if (formByNetwork) layers.push(formByNetwork)
            if (formByPage) layers.push(formByPage)
        }

        // les couches sont des diffs : la premiere en partant de la plus prioritaire qui possede
        // la clé gagne
        const resolve = (key) => {
            for (let i = layers.length - 1; i >= 0; i--) {
                if (layers[i] && layers[i].hasOwnProperty(key)) return layers[i][key]
            }
            return undefined
        }

        // `mentions` est un dictionnaire : on empile les couches au lieu de n'en garder qu'une
        // (meme merge a plat que RenderPostManager.vue et setPagesInstagramActivedShareStory)
        const mentions = layers.reduce((acc, layer) => (
            layer && layer.mentions ? { ...acc, ...layer.mentions } : acc
        ), {})

        const countText = countMentionsPerNetwork(resolve('textContent'), mentions)[network] || 0

        // un commentaire Facebook est un objet a part, avec sa propre liste de mentions : on le
        // compte separement du post au lieu de tout additionner
        const comments = (resolve('comments') || []).reduce((acc, comment, index) => {
            const count = countMentionsPerNetwork(comment, mentions)[network] || 0
            if (count > maxMentions) acc.push({ index, count })
            return acc
        }, [])

        if (countText > maxMentions || comments.length) {
            result[page.id] = { count: countText, comments }
        }
    })

    return result
}

export const foreachSaveAllFormData = async (saveAllFormData, cb) => {
    if (saveAllFormData.main) await cb(saveAllFormData.main, 'main')
    if (saveAllFormData.networks) {
        for (const [networkName, value] of Object.entries(saveAllFormData.networks)) {
            await cb(saveAllFormData.networks[networkName], 'network')
        }          
    }

    if (saveAllFormData.pages) {
        for (const [pageId, value] of Object.entries(saveAllFormData.pages)) {
            await cb(saveAllFormData.pages[pageId], 'page')
        }  
    }
}

function canvasToBlobURL(canvas, quality) {
    return new Promise((resolve) => {
        canvas.toBlob((blob) => {
            const blobUrl = URL.createObjectURL(blob);
            resolve(blobUrl);
        }, 'image/jpeg', quality);
    });
}
